"use client"

import {observer} from "mobx-react";
import * as React from "react";
import styles from "./styles/CleverFeedNavigationPrimary.module.scss"
import ClickableLink from "../../utilities/ClickableLink";
import UserDropDownMenu from "../UserDropDownMenu";
import classNames from 'classnames';
import {useMainUrl} from "../../../hooks/useMainUrl";
import ImageComponent from "../../utilities/ImageComponent";
import {color_lightness} from "../../../utils/colorcontrast";
import {useStores} from "../../../stores/useStores";

const CleverFeedNavigationPrimary = observer((props) => {
    const {organizationStore, interfaceStore} = useStores();

    const primaryNavClassName = classNames({
        "sb-navbar-background": true,
        "sb-organization-color-primary-nav": true,
        [styles.primaryNav]: true,
    })
    const primaryNavElementCellClassName = classNames({
        "sb-navbar-primary-element": true,
        "sb-navbar-margin-top": true,
        [styles.inlineBlock]: true,
    })

    return (
        <div className={primaryNavClassName}>
            <div className={styles.primaryNavContent}>
                <div className={styles.title}>
                    <ClickableLink aria-label={"Go to Home Page"}
                                   title={"Go to Home Page"}
                                   href={useMainUrl()}>
                        <h1>{organizationStore.organization.title}</h1>
                    </ClickableLink>
                </div>
                <div className={styles.buttons}>
                    {interfaceStore.breakpoint !== 'break-point-xs' && <div className="sb-navbar-cell" id={'search-cell'}>
                        <div className={primaryNavElementCellClassName}>
                            <ClickableLink
                                href={"/search"}
                                className="sb-organization-font-color"
                                rel="noopener noreferrer"
                                aria-label="Link to Search Page"
                                title="Link to Search Page"
                                tabIndex={props.preventTabbing ? -1 : 0}
                            ><span
                                className="fas  fa-search sb-navbar-search-icon" role="presentation"
                                aria-hidden="true"/></ClickableLink>
                        </div>
                    </div>}
                    <div>
                        <UserDropDownMenu customLoginText={"Join the Discussion"}/>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default CleverFeedNavigationPrimary;
